import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { ErrorBadgeIcon } from '@frontend/design-system';

const styles = {
  container: css`
    width: 350px;
    padding: 16px;
    margin: auto;
    margin-top: 0px;
  `,
  resultMessage: css`
    text-align: center;
    max-width: 400px;
    margin: 0 auto;
  `,
  errorIcon: css`
    margin: 20px auto;
  `,
  errorBody: css`
    line-height: 21px;
  `,
};
export const ErrorComponent = () => {
  const { t } = useTranslation('weave-pay');
  return (
    <div css={styles.container}>
      <div css={styles.resultMessage}>
        <h1>{t('Whoops!')}</h1>
        <p css={styles.errorBody}>
          {t('An error occurred. Please try again. If you continue to get this message, please request a new link.')}
        </p>
        <ErrorBadgeIcon css={styles.errorIcon} color='error' size={150} />
      </div>
    </div>
  );
};
